export default __webpack_public_path__ + "static/jonas-1925425614666806fd07552272495d36.png";